module.exports = __webpack_public_path__ + "static/media/350.79e804a6.svg";